import { useShortCodeDataCemeteries } from '@/hooks/use-short-code-data/use-short-code-data'
import { FC } from 'react'
import { css } from '@emotion/react'
import { palette } from '@lifedot/styles/palette'
import { typography } from '@lifedot/styles/typography'
import { EventTracker } from '@lifedot/tracking'
import { elementCategories } from '@lifedot/constants/elementCategories'
import { router } from '@lifedot/router'
import Link from 'next/link'
import { Button } from '@lifedot/atoms/Button'
import { CemeteryInfo } from './CemeteryInfo'
import { AccessText } from './AccessText'
import { RecommendPoints } from './RecommendPoints'
import { Prices } from './Prices'
import { Review } from './Review'

const styles = {
  postH3: css({
    position: 'relative',
    borderBottom: `solid 3px ${palette.gray2}`,
    padding: '4px 0px',
    margin: '2em 0 1em',
    '&::after': {
      content: '""',
      position: 'absolute',
      background: palette.main,
      height: 3,
      left: 0,
      bottom: -3,
      width: '20%'
    }
  }),
  button: css({
    display: 'block',
    maxWidth: 400,
    textDecoration: 'none',
    margin: '24px auto 0'
  }),
  buttonSubText: css({
    display: 'block'
  })
}

interface CemeteryIntroductionProps {
  cemeteryId: number
  choiceCode: string
}

export const CemeteryIntroduction: FC<CemeteryIntroductionProps> = ({
  cemeteryId,
  choiceCode
}) => {
  const [cemetery] = useShortCodeDataCemeteries([cemeteryId])

  if (!cemetery) return null

  const { name, requestable, prefecture, city } = cemetery

  return (
    <article>
      <h3 css={[typography.headingM, styles.postH3]}>
        {name} | {prefecture.name}
        {city.name}
      </h3>
      <CemeteryInfo cemeteryId={cemeteryId} />
      <AccessText cemeteryId={cemeteryId} choiceCode={choiceCode} />
      <RecommendPoints cemeteryId={cemeteryId} />
      <Prices cemeteryId={cemeteryId} choiceCode={choiceCode} />
      <Review cemeteryId={cemeteryId} />
      {requestable && (
        <EventTracker
          label={`cemeteryIntroduction_cta_${cemeteryId}`}
          action="click"
          elementCategory={elementCategories.cemeteryIntroduction}
          elementLabel={`cta_${cemeteryId}`}
        >
          <Link
            href={router.requestsNew({ id: cemeteryId })}
            passHref
            prefetch={false}
          >
            <a css={styles.button}>
              <Button
                subText={
                  <span css={[typography.textS, styles.buttonSubText]}>
                    この霊園の
                  </span>
                }
                mainText={<span>パンフレットを請求する</span>}
                color="accent"
                as="div"
              />
            </a>
          </Link>
        </EventTracker>
      )}
    </article>
  )
}
